module.exports = __webpack_public_path__ + "static/img/main14.1da42a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/main14.png
// module id = O7PL
// module chunks = 1